/*============================================================
   1. REACT DEPENDENCIES
============================================================*/
import React from "react";
import ReactDOM from "react-dom/client";

/*============================================================
   1. REDUX DEPENDENCIES

   2. CREATED A REDUX STORE
      NOTE:
      - MULTIPLE DATA SLICES ARE DECLAERED
      - A STORE CONFIGURATION IS CREATED TOP MAP REDUCERS --> EACH DATA SLICE
============================================================*/
import { Provider } from "react-redux";

//STORE
//import store from "./store/store.js";

//STORE - PERSISTED
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/persistant-store.js";

/*============================================================
   1. MUI DEPENDENCIES
   2. APPLICATION
============================================================*/
import { ThemeProvider, createTheme } from "@mui/material";
import App from "./App";

const theme = createTheme({
  palette: {
    primary: {
      main: "#3385ff",
    },
    secondary: {
      main: "#000000",
    },
  },
});

//NO REDUX PERSISTAMT
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <ThemeProvider theme={theme}>
//     <Provider store={store}>
//       <App />
//     </Provider>
//   </ThemeProvider>
// );

//WITH REDUX PERSISTANT
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </ThemeProvider>
);
